import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DecedatiComponent } from './decedati.component';
import { AddDecedatiComponent } from './add-decedati/add-decedati.component';
import { EditDecedatiComponent } from './edit-decedati/edit-decedati.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        DecedatiComponent,
        AddDecedatiComponent,
        EditDecedatiComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [DecedatiComponent]
})
export class DecedatiModule { }
